import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useBreakpoints, useTheme } from '@monorepo/nova-ui';
import { useNotifications } from '../../../hooks';

type Props = {
  readAllEnabled: boolean;
  historyEnabled: boolean;
  setShowHistory: (showHistory: boolean) => void;
};

export const NotificationsFooter: FC<Props> = ({
  readAllEnabled,
  historyEnabled,
  setShowHistory,
}) => {
  const { t } = useTranslation(['notificationCenter']);
  const { palette } = useTheme();
  const { isMobile } = useBreakpoints();
  const { handleReadAll } = useNotifications();

  if (!historyEnabled && !isMobile) {
    return null;
  }

  return (
    <Box
      position="sticky"
      bottom={0}
      zIndex={1}
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={56}
      minHeight={56}
      paddingX="20px"
      sx={{
        backgroundColor: isMobile
          ? palette.background.paper
          : palette.background.contrast,
      }}
    >
      <Typography
        variant="button"
        onClick={historyEnabled ? () => setShowHistory(true) : undefined}
        fontSize={14}
        fontWeight={500}
        color={historyEnabled ? palette.primary.main : palette.grey[500]}
        sx={{
          cursor: historyEnabled ? 'pointer' : 'default',
          '&:hover': {
            color: historyEnabled ? palette.primary.light : undefined,
          },
        }}
      >
        {t('notificationCenter:view_notification_history')}
      </Typography>
      {isMobile && (
        <Typography
          variant="button"
          onClick={readAllEnabled ? handleReadAll : undefined}
          color={readAllEnabled ? palette.primary.main : palette.grey[500]}
          sx={{
            marginLeft: 'auto',
            cursor: readAllEnabled ? 'pointer' : 'default',
            '&:hover': {
              color: readAllEnabled ? palette.primary.light : undefined,
            },
          }}
        >
          {t('notificationCenter:read_all')}
        </Typography>
      )}
    </Box>
  );
};
